<template src="./integrationSetupDetails.template.html"></template>
<script>
    export default {
        name: "integrationSetupDetails",
        props: ["selectedIntegration", "parentComponentName", "refreshIntegrationList"],
        data() {
            return {
                integrationAccountList: [],
                ShowAllAccount: true,
                showIntegrationDetailsValuesInput: false,
                integrationAccountDetails: {
                    Integrators_UserId: null,
                    AccountSID: null,
                    AuthToken: null,
                    IntegrationKey: null,
                    BasePath: null,
                    RsaKey: null,
                    PhoneNumber: null
                }
            }
        },
        methods: {
            GetIntegrationAccountList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations_RU",
                    params: {
                        ModuleAction: "Get_ListOfIntegrations_RU",
                        PropertyId: null,
                        UnitId: null
                    },
                    callback: function (err, response) {
                        console.log("GetWheelHouseUserList", response)
                        if (response[0].length) {
                            vm.integrationAccountList = response[0]
                        }
                    }
                })
            },
            connectExistingAccount(event) {
                let vm = this;
                event.stopPropagation();
                vm.showIntegrationDetailsValuesInput = true;
                vm.integrationAccountDetails = {
                    Integrators_UserId: null,
                    AccountSID: null,
                    AuthToken: null,
                    IntegrationKey: null,
                    BasePath: null,
                    RsaKey: null,
                    PhoneNumber: null
                }
            },
            createIntegrationAccount(event) {
                let vm = this;
                event.stopPropagation();
            },
            filterInput(event) {
      const allowedCharacters = /^[0-9+]+$/;
      if (!allowedCharacters.test(event.key)) {
        event.preventDefault();
      }
    },
            saveConnectionDetails(event) {
                let vm = this;
                vm.$validator.validateAll().then((result) => {
                    if (result) {
                        vm.$store.dispatch("dataRequestHandler", {
                            key: "SaveIntegrations",
                            params: {
                                ModuleAction: "SaveIntegrations",
                                crsId: null,
                                // ClientCode: null,
                                username: vm.integrationAccountDetails.UserName,
                                password: null,
                                statusId: 1,
                                isDefault: true,
                                IntegrationId: vm.selectedIntegration.IntegrationId,
                                Integrators_UserId: vm.integrationAccountDetails.Integrators_UserId,
                                AccountSID: vm.integrationAccountDetails.AccountSID,
                                AuthToken: vm.integrationAccountDetails.AuthToken,
                                IntegrationKey: vm.integrationAccountDetails.IntegrationKey,
                                BasePath: vm.integrationAccountDetails.BasePath,
                                RsaKey: vm.integrationAccountDetails.RsaKey,
                                PhoneNumber: vm.integrationAccountDetails.PhoneNumber
                            },
                            callback: function (err, response) {
                                if (err) {
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        header: "Error!",
                                        message: "Error in creating Account"
                                    });
                                    return
                                }
                                if (response && (response.docuSignResponse || response.recordsets)) {
                                    let hasInvalidCredentials = response.docuSignResponse && response.docuSignResponse.credentials === false;
                                    let hasErrorMessage = response.recordsets && response.recordsets[0] && response.recordsets[0][0] && response.recordsets[0][0].ErrorMessage;
                                    let userNotFound = response.docuSignResponse && response.docuSignResponse.userNotFound === true;
                                    if (response.docuSignResponse && response.docuSignResponse.emailSent) {
                                        vm.$store.dispatch("toastr", {
                                            type: "info",
                                            header: "Verification Request",
                                            message: `Verification link has been sent to ${response.docuSignResponse.emailUserData.email}`
                                        });
                                        vm.closeAccoutPanel();
                                        vm.selectedIntegration.IsIntegrated = true;
                                    }
                                    if(userNotFound){
                                        vm.$store.dispatch("toastr", {
                                            type: "error",
                                            message: response.docuSignResponse.message,
                                            header: "Error!"
                                        });
                                        vm.closeAccoutPanel();
                                        vm.selectedIntegration.IsIntegrated = true;
                                    }
                                    if(response && response.docuSignResponse && response.docuSignResponse.invalid_user){
                                        vm.$store.dispatch("toastr", {
                                            type: "error",
                                            message: response.docuSignResponse.message,
                                            header: "Error!"
                                        });
                                        vm.updateIntegrationStatus(12, '-2');
                                        vm.closeAccoutPanel();
                                        vm.selectedIntegration.IsIntegrated = true;
                                    }
                                    if (hasInvalidCredentials) {
                                        vm.$store.dispatch("toastr", {
                                            type: "error",
                                            message: 'Invalid DocuSign Credentials',
                                            header: "Error!"
                                        });
                                        vm.updateIntegrationStatus(12, '-2');
                                        vm.closeAccoutPanel();
                                        vm.selectedIntegration.IsIntegrated = false;
                                    } else {
                                        if (hasErrorMessage) {
                                            vm.$store.dispatch("toastr", {
                                                type: "error",
                                                message: response.recordsets[0][0].ErrorMessage,
                                                header: "Error!"
                                            });
                                        } else {
                                            console.log("user fin--inactive = ", response);
                                            vm.$store.dispatch("toastr", {
                                                type: "success",
                                                header: "Integration",
                                                message: "Account Added"
                                            });
                                            vm.closeAccoutPanel();
                                            vm.selectedIntegration.IsIntegrated = true;
                                        }
                                    }
                                    vm.refreshIntegrationList();
                                    vm.GetIntegrationAccountList();
                                }
                            }
                        })
                    }
                    else {
                        vm.$store.dispatch("toastr", {
                            type: "warning",
                            header: "warning!",
                            message: "Enter the integration details"
                        });
                    }
                })
            },
            closeAccoutPanel() {
                let vm = this;
                vm.showIntegrationDetailsValuesInput = false
            },
            updateIntegrationStatus(integrationId, status) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "SaveIntegrations",
                    params: {
                        ModuleAction: "SaveIntegrations",
                        statusId: status,
                        IntegrationId: vm.selectedIntegration.IntegrationId,
                    },
                    callback: function (err, response) {

                        if (err) {
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "Something Went Wrong"
                            });
                            return
                        }
                        if (response) {
                            if (response.recordsets && response.recordsets[0] && response.recordsets[0][0] && response.recordsets[0][0].ErrorMessage) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: response.recordsets[0][0].ErrorMessage,
                                    header: "Error!"
                                });
                            } else {
                                console.log("user fin--inactive = ", response)
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Integration",
                                    message: "Account Deleted"
                                });
                                vm.closeAccoutPanel();
                                vm.selectedIntegration.IsIntegrated = true
                            }
                            vm.refreshIntegrationList()
                            vm.GetIntegrationAccountList();

                        }
                    }
                })
            }
        },
        mounted() {
            let vm = this;
            vm.GetIntegrationAccountList();
        }
    }
</script>